import { getAssetPath } from '../utils/assets';

// Basic Mode - 20 Chinese Characters
// 木 水 火 山 雨 日 土 月 人 天 大 女 田 心 男 石 光 兄 父 妹
export const basicStages = [
  {
    id: 1001,
    name: '木 (Wood)',
    chinese: '木',
    english: 'Wood',
    image: getAssetPath('puzzles/easy/wood.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1002,
    name: '水 (Water)',
    chinese: '水',
    english: 'Water',
    image: getAssetPath('puzzles/easy/water.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1003,
    name: '火 (Fire)',
    chinese: '火',
    english: 'Fire',
    image: getAssetPath('puzzles/easy/fire.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1004,
    name: '山 (Mountain)',
    chinese: '山',
    english: 'Mountain',
    image: getAssetPath('puzzles/easy/mountain.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1005,
    name: '雨 (Rain)',
    chinese: '雨',
    english: 'Rain',
    image: getAssetPath('puzzles/easy/rain.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1006,
    name: '日 (Sun)',
    chinese: '日',
    english: 'Sun',
    image: getAssetPath('puzzles/easy/sun.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1007,
    name: '土 (Ground)',
    chinese: '土',
    english: 'Ground',
    image: getAssetPath('puzzles/easy/ground.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1008,
    name: '月 (Moon)',
    chinese: '月',
    english: 'Moon',
    image: getAssetPath('puzzles/easy/moon.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1009,
    name: '人 (Human)',
    chinese: '人',
    english: 'Human',
    image: getAssetPath('puzzles/easy/human.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1010,
    name: '天 (Sky)',
    chinese: '天',
    english: 'Sky',
    image: getAssetPath('puzzles/easy/sky.jpg'),
    mode: 'easy',
    difficulty: 1
  },
  {
    id: 1011,
    name: '大 (Big)',
    chinese: '大',
    english: 'Big',
    image: getAssetPath('puzzles/easy/big.jpg'),
    mode: 'easy',
    difficulty: 2
  },
  {
    id: 1012,
    name: '女 (Woman)',
    chinese: '女',
    english: 'Woman',
    image: getAssetPath('puzzles/easy/daughter.jpg'),
    mode: 'easy',
    difficulty: 2
  },
  {
    id: 1013,
    name: '田 (Field)',
    chinese: '田',
    english: 'Field',
    image: getAssetPath('puzzles/easy/rice field.jpg'),
    mode: 'easy',
    difficulty: 2
  },
  {
    id: 1014,
    name: '心 (Heart)',
    chinese: '心',
    english: 'Heart',
    image: getAssetPath('puzzles/easy/Heart.jpg'),
    mode: 'easy',
    difficulty: 2
  },
  {
    id: 1015,
    name: '男 (Man)',
    chinese: '男',
    english: 'Man',
    image: getAssetPath('puzzles/easy/men.jpg'),
    mode: 'easy',
    difficulty: 2
  },
  {
    id: 1016,
    name: '石 (Rock)',
    chinese: '石',
    english: 'Rock',
    image: getAssetPath('puzzles/easy/rock.jpg'),
    mode: 'easy',
    difficulty: 2
  },
  {
    id: 1017,
    name: '光 (Light)',
    chinese: '光',
    english: 'Light',
    image: getAssetPath('puzzles/easy/light.jpg'),
    mode: 'easy',
    difficulty: 2
  },
  {
    id: 1018,
    name: '兄 (Elder Brother)',
    chinese: '兄',
    english: 'Elder Brother',
    image: getAssetPath('puzzles/easy/older brother.jpg'),
    mode: 'easy',
    difficulty: 3
  },
  {
    id: 1019,
    name: '父 (Father)',
    chinese: '父',
    english: 'Father',
    image: getAssetPath('puzzles/easy/father.jpg'),
    mode: 'easy',
    difficulty: 3
  },
  {
    id: 1020,
    name: '妹 (Younger Sister)',
    chinese: '妹',
    english: 'Younger Sister',
    image: getAssetPath('puzzles/easy/Younger sister.jpg'),
    mode: 'easy',
    difficulty: 3
  }
];

// Advanced Mode - 20 Chinese Characters
// 海 春 夏 秋 冬 學 善 美 愛 危 風 星 快 毒 島 電 燒 寫 飛 慢
export const advancedStages = [
  {
    id: 2001,
    name: '海 (Ocean)',
    chinese: '海',
    english: 'Ocean',
    image: getAssetPath('puzzles/hard/ocean.jpg'),
    mode: 'hard',
    difficulty: 1
  },
  {
    id: 2002,
    name: '春 (Spring)',
    chinese: '春',
    english: 'Spring',
    image: getAssetPath('puzzles/hard/spring.jpg'),
    mode: 'hard',
    difficulty: 1
  },
  {
    id: 2003,
    name: '夏 (Summer)',
    chinese: '夏',
    english: 'Summer',
    image: getAssetPath('puzzles/hard/summer.jpg'),
    mode: 'hard',
    difficulty: 1
  },
  {
    id: 2004,
    name: '秋 (Autumn)',
    chinese: '秋',
    english: 'Autumn',
    image: getAssetPath('puzzles/hard/autumn.jpg'),
    mode: 'hard',
    difficulty: 1
  },
  {
    id: 2005,
    name: '冬 (Winter)',
    chinese: '冬',
    english: 'Winter',
    image: getAssetPath('puzzles/hard/winter.jpg'),
    mode: 'hard',
    difficulty: 1
  },
  {
    id: 2006,
    name: '學 (Study)',
    chinese: '學',
    english: 'Study',
    image: getAssetPath('puzzles/hard/learn.jpg'),
    mode: 'hard',
    difficulty: 2
  },
  {
    id: 2007,
    name: '善 (Kindness)',
    chinese: '善',
    english: 'Kindness',
    image: getAssetPath('puzzles/hard/kindness.jpg'),
    mode: 'hard',
    difficulty: 2
  },
  {
    id: 2008,
    name: '美 (Beauty)',
    chinese: '美',
    english: 'Beauty',
    image: getAssetPath('puzzles/hard/beauty.jpg'),
    mode: 'hard',
    difficulty: 2
  },
  {
    id: 2009,
    name: '慢 (Slow)',
    chinese: '慢',
    english: 'Slow',
    image: getAssetPath('puzzles/hard/slow.jpg'),
    mode: 'hard',
    difficulty: 2
  },
  {
    id: 2010,
    name: '危 (Danger)',
    chinese: '危',
    english: 'Danger',
    image: getAssetPath('puzzles/hard/danger.jpg'),
    mode: 'hard',
    difficulty: 2
  },
  {
    id: 2011,
    name: '風 (Wind)',
    chinese: '風',
    english: 'Wind',
    image: getAssetPath('puzzles/hard/wind.jpg'),
    mode: 'hard',
    difficulty: 2
  },
  {
    id: 2012,
    name: '星 (Star)',
    chinese: '星',
    english: 'Star',
    image: getAssetPath('puzzles/hard/star.jpg'),
    mode: 'hard',
    difficulty: 2
  },
  {
    id: 2013,
    name: '快 (Fast)',
    chinese: '快',
    english: 'Fast',
    image: getAssetPath('puzzles/hard/quick.jpg'),
    mode: 'hard',
    difficulty: 3
  },
  {
    id: 2014,
    name: '毒 (Poison)',
    chinese: '毒',
    english: 'Poison',
    image: getAssetPath('puzzles/hard/poison.jpg'),
    mode: 'hard',
    difficulty: 3
  },
  {
    id: 2015,
    name: '島 (Island)',
    chinese: '島',
    english: 'Island',
    image: getAssetPath('puzzles/hard/island.jpg'),
    mode: 'hard',
    difficulty: 3
  },
  {
    id: 2016,
    name: '電 (Electricity)',
    chinese: '電',
    english: 'Electricity',
    image: getAssetPath('puzzles/hard/electricity.jpg'),
    mode: 'hard',
    difficulty: 3
  },
  {
    id: 2017,
    name: '燒 (Burn)',
    chinese: '燒',
    english: 'Burn',
    image: getAssetPath('puzzles/hard/burn.jpg'),
    mode: 'hard',
    difficulty: 3
  },
  {
    id: 2018,
    name: '寫 (Write)',
    chinese: '寫',
    english: 'Write',
    image: getAssetPath('puzzles/hard/Write.jpg'),
    mode: 'hard',
    difficulty: 3
  },
  {
    id: 2019,
    name: '飛 (Fly)',
    chinese: '飛',
    english: 'Fly',
    image: getAssetPath('puzzles/hard/Fly.jpg'),
    mode: 'hard',
    difficulty: 3
  },
  {
    id: 2020,
    name: '愛 (Love)',
    chinese: '愛',
    english: 'Love',
    image: getAssetPath('puzzles/hard/love.jpg'),
    mode: 'hard',
    difficulty: 3
  }
];

// Legacy exports for backward compatibility
export const easyStages = basicStages;
export const hardStages = advancedStages;

// Combine all preloaded stages
export const defaultStages = [...basicStages, ...advancedStages];
